import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Control from "react-leaflet-custom-control";
import LegendToggleIcon from "@mui/icons-material/LegendToggle";
import CloseIcon from "@mui/icons-material/Close";
import greenCorridorsStaticData from "../../livemap-ui-green-corridors-regions";
import polylineColors from "../shared/map-polyline-colors";
import { useTranslation } from "react-i18next";

/**
 * Used to to show  a map polylines legend
 * @component
 * @category Components
 * @subcategory Map
 */

const greenCorridorTrams = [];
const greenCorridorTrolleys = [];
const greenCorridorBuses = [];

greenCorridorsStaticData.forEach((x) => {
  x.tramLines.forEach((z) => greenCorridorTrams.push(z));
  x.trolleyLines.forEach((c) => greenCorridorTrolleys.push(c));
  x.busLines.forEach((v) => greenCorridorBuses.push(v));
});

const PolylinesLegend = () => {
  const { t } = useTranslation();
  const { selectedTab, navigation } = useSelector((state) => ({
    selectedTab: state.shared.selectedNavigationTab,
    navigation: state.navigation,
  }));

  const legendContents = {
    PUBLIC_TRANSIT: {
      bus: { isActive: false, color: polylineColors.buses, title: "BUSES" },
      tram: { isActive: false, color: polylineColors.trams, title: "TRAMS" },
      trolley: { isActive: false, color: polylineColors.trolleys, title: "TROLLEYS_AND_EBUSES" },
      subwayLines: { isActive: false, color: polylineColors.subwayLines, title: "SUBWAY" },
    },
    ALTERNATIVE_TRANSIT: {
      cycleways: { isActive: false, color: polylineColors.cycleways, title: "CYCLEWAYS" },
    },
    GREEN_INFRASTRUCTURE: {
      bus: { isActive: false, color: polylineColors.buses, title: "BUSES" },
      tram: { isActive: false, color: polylineColors.trams, title: "TRAMS" },
      trolley: { isActive: false, color: polylineColors.trolleys, title: "TROLLEYS_AND_EBUSES" },
      corridors: { isActive: false, color: polylineColors.corridors, title: "GREEN_CORRIDOR" },
    },
    RECONSTRUCTIONS: {
      zones: { isActive: false, color: polylineColors.reconstructions, title: "RECONSTRUCTIONS" },
    },
  };

  const [showLegendContainer, toggle] = useState(true);

  const [filteredContents, setFilteredContents] = useState([]);

  const toggler = () => {
    toggle(!showLegendContainer);
  };
  useEffect(() => {}, [showLegendContainer]);
  useEffect(() => {}, [selectedTab]);
  useEffect(() => {
    if (selectedTab === "PUBLIC_TRANSIT") {
      legendContents[selectedTab].bus.isActive = navigation.bus.isActive;
      legendContents[selectedTab].tram.isActive = navigation.tram.isActive;
      legendContents[selectedTab].trolley.isActive = navigation.trolley.isActive;
      legendContents[selectedTab].subwayLines.isActive = navigation.subwayLines.isActive;
    }
    if (selectedTab === "ALTERNATIVE_TRANSIT") {
      legendContents[selectedTab].cycleways.isActive = navigation.cycleways.isActive;
    }
    if (selectedTab === "GREEN_INFRASTRUCTURE") {
      const keys = Object.keys(navigation).filter((x) => x.includes("greenCorridor"));

      for (let i = 0; i < keys.length; i++) {
        if (navigation[[keys[i]]].isActive) {
          legendContents[selectedTab].bus.isActive = greenCorridorBuses.length > 0;
          legendContents[selectedTab].tram.isActive = greenCorridorTrams.length > 0;
          legendContents[selectedTab].trolley.isActive = greenCorridorTrolleys.length > 0;
          legendContents[selectedTab].corridors.isActive = true;
        } else {
          legendContents[selectedTab].bus.isActive = false;
          legendContents[selectedTab].tram.isActive = false;
          legendContents[selectedTab].trolley.isActive = false;
          legendContents[selectedTab].corridors.isActive = false;
        }
      }
    }
    if (selectedTab === "RECONSTRUCTIONS") {
      legendContents[selectedTab].zones.isActive = navigation.reconstructionsTemporary.isActive;
    }
    setFilteredContents(Object.values(legendContents[selectedTab]).filter((x) => x.isActive));
  }, [navigation]);

  return (
    <>
      {filteredContents.length ? (
        <Control position={"topleft"}>
          <div className='container map-selector' style={{ padding: 0, maxHeight: "50vh" }}>
            <div>
              <button
                className={showLegendContainer ? "maplayers-button close-hover" : "maplayers-button"}
                onClick={() => toggler()}>
                {showLegendContainer ? <CloseIcon /> : <LegendToggleIcon />}
              </button>
            </div>
            {showLegendContainer ? (
              <div className='map-polyline-legend'>
                {filteredContents.map((x) => {
                  return (
                    <div className='map-polyline-legend-row' key={x.title + "-" + "selectedTab"}>
                      <div style={{ backgroundColor: x.color, width: "70px", height: "6px" }}></div>
                      <div style={{ width: "70x", fontSize: "10px", textAlign: "center" }}>{t(x.title)}</div>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
        </Control>
      ) : null}
    </>
  );
};
export default React.memo(PolylinesLegend);
